import { render } from "./otp.html?vue&type=template&id=2d733dd2&scoped=true&ts=true"
import script from "./otp.vue?vue&type=script&lang=ts"
export * from "./otp.vue?vue&type=script&lang=ts"

import "./otp.scss?vue&type=style&index=0&id=2d733dd2&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d733dd2"]])

export default __exports__